'use client'

import { useTranslations } from 'next-intl'

import { useDialogState } from '@/shared/lib'
import { Button, Icon } from '@/shared/ui'

import { PASSPORT_VERIFICATION_DIALOG } from './passport-dialog'

export type Props = {
  isVerified?: boolean
  disabled?: boolean
}

export const PassportVerificationButton = ({
  isVerified = false,
  disabled = false,
}: Props) => {
  const t = useTranslations()

  const { open } = useDialogState()

  const handleClick = () => {
    open(PASSPORT_VERIFICATION_DIALOG, { closeOnOpen: true })
  }

  return (
    <>
      {(() => {
        if (isVerified) {
          return (
            <Button
              variant="outline"
              shape="pill"
              size="medium"
              className="typo-label1 w-full"
              onClick={handleClick}
            >
              {t('passport_verification.button.reupload_passport')}
              <Icon name="arrow-right" size={24} />
            </Button>
          )
        }

        return (
          <Button
            variant="outline"
            shape="pill"
            size="medium"
            className="typo-label1 w-full"
            disabled={disabled}
            onClick={handleClick}
          >
            {t('verification.button.verify_passport')}
            <Icon name="arrow-right" size={24} />
          </Button>
        )
      })()}
    </>
  )
}
